
const isDarkTheme = themeName => themeName === 'dark' || themeName === 'aaa-dark';

export { isDarkTheme as default };